import { useAuth } from "@/contexts/auth-context";

export function useHideElectricity(): boolean {
	return useAuth().user?.hide_electricity ?? false;
}
